export const SOCKET = {
  createNotify: "createNotify",
  addMessage: "addMessage",
  createNotifyToClient: "createNotifyToClient",
};
